/**
 * Query keys das despesas (`club_expenses`) de /despesas.
 *
 * A raiz é a key LEGADA `['club_expenses']`, de antes do factory: as mutações
 * do próprio `useExpenses`, a compra de estoque do PDV (`useProducts`) e o
 * pagamento de comissão (`useTeacherCommissions`) invalidam por esse prefixo —
 * trocar a raiz deixaria a lista velha depois de cada uma delas.
 *
 * O painel financeiro tem a sua (`qk.financial.expenses`), de outra raiz.
 */
import { tuple } from "./core";

const root = ["club_expenses"] as const;

export const expenses = {
  /** Prefixo raiz — invalidar isto atualiza lista e totais. */
  all: root,
  /** Página da lista: o recorte, a ordem e a página são caches distintos. */
  list: (
    clubId: string | null | undefined,
    viewScope: unknown,
    filtros: unknown,
    ordenacao: unknown,
    page: number,
    pageSize: number,
  ) => tuple(root, clubId, viewScope, "lista", filtros, ordenacao, page, pageSize),
  /** Cards de totais do recorte inteiro (sem ordem nem página). */
  totais: (clubId: string | null | undefined, viewScope: unknown, filtros: unknown) =>
    tuple(root, clubId, viewScope, "totais", filtros),
} as const;
